import { render } from "./supportPage.vue?vue&type=template&id=7eb9b289&scoped=true"
import script from "./supportPage.vue?vue&type=script&lang=js"
export * from "./supportPage.vue?vue&type=script&lang=js"

import "./supportPage.vue?vue&type=style&index=0&id=7eb9b289&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb9b289"]])

export default __exports__